import React, { useState } from 'react';
import { initialsFromName } from '../utils/headshot';

const SIZE_CLASS = {
  sm: 'w-9 h-9 text-xs',
  md: 'w-14 h-14 text-sm',
  lg: 'w-24 h-24 text-xl',
  xl: 'w-32 h-32 text-2xl'
};

/**
 * Circular roster photo with initials fallback. `headshotUrl` is a public
 * image URL (Vercel Blob in production, local /uploads in development).
 */
export default function AthleteHeadshot({
  name,
  headshotUrl,
  size = 'md',
  className = ''
}) {
  const [failed, setFailed] = useState(false);
  const showPhoto = Boolean(headshotUrl) && !failed;
  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.md;

  return (
    <div
      className={`${sizeClass} rounded-full overflow-hidden bg-theme-primary/10 text-theme-primary flex items-center justify-center font-bold shrink-0 ${className}`}
      aria-hidden={showPhoto ? 'true' : undefined}
      title={name}
    >
      {showPhoto ? (
        <img
          src={headshotUrl}
          alt=""
          className="w-full h-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <span>{initialsFromName(name)}</span>
      )}
    </div>
  );
}
